<template>
  <div v-show='cpntMostrar' class="rf-input-group" :class='cpntClassDivField'>
    <template v-if='cpntStatus !== ""'>
      <RF-Status :cpntStatus='cpntStatus' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if="[ '', null, undefined ].indexOf(colorValue) === -1">
      <div>
        <label :for='cpntId' :class='"has-" + cpntMensagemTipo' style="margin-top: -22px;">
          <span v-html='cpntNome'></span>

          <RF-Explica v-if='[ "", null, undefined ].indexOf(cpntExplica) === -1 && Object.keys(cpntExplica).length >= 1'
            :cpntId='cpntId + "-explica"' 
            :cpntTitle='cpntExplica.mensagem'
            :cpntPositionMy='cpntExplica.posicaoMy'
            :cpntPositionAt='cpntExplica.posicaoAt'
            :cpntClasses='cpntExplica.class'

            style='vertical-align: 0px;'
          ></RF-Explica>
        </label>

        <div class="input-group color-picker" ref="colorpicker" style="margin-top: -4px;">
          <input type="text" class="form-control" v-model="colorValue" @focus="showPicker()" @input="updateFromInput" />
          <span class="input-group-addon color-picker-container" @click="togglePicker()">
            <span class="current-color" :style="'background-color: ' + colorValue" ></span>
          </span>
          <color-picker :value="colors" :disableAlpha="true" @input="updateFromPicker" v-if="displayPicker" @blur="displayPicker = !displayPicker"/>
        </div>
      </div>

      <span v-if='cpntMensagem !== "" && cpntMensagem !== null' v-html='cpntMensagem' :class='"has-" + cpntMensagemTipo'></span>
    </template>
  </div>
</template>

<style scoped>
h1 {
	height: 120px;
	line-height: 120px;
	text-align: center;
}
.vc-chrome {
	position: absolute;
	top: 35px;
	right: 0;
	z-index: 9;
}
.current-color {
	display: inline-block;
	width: 16px;
	height: 16px;
	background-color: #000;
	cursor: pointer;
}
.footer {
	margin-top: 20px;
	text-align: center;
}
</style>

<style>
  .vc-chrome {
    position: fixed !important;
    top: auto !important;
    right: auto !important;
  }
</style>

<script>
  export default {
    components: {
      'RF-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue'),
      'color-picker': () => import('../../../../node_modules/vue-color/src/components/Chrome.vue')
      // 'color-picker': import('vue-color')
    },
    props: {
      cpntStatus: {
        required: true
      },
      cpntId: {
        required: true,
        type: String
      },
      cpntTabIndex: {
        required: false,
        type: Number,
        default: function () {
          return 0
        }
      },
      cpntNome: {
        required: true,
        type: [ String, Number ],
        default: function () {
          return ''
        }
      },
      cpntType: {
        required: false,
        type: String,
        validator: function (val) {
          return ([ 'text', 'password', 'number' ].indexOf(val) !== -1)
        },
        default: function () {
          return 'text'
        }
      },
      cpntValue: {
        required: true,
        type: [ String, Number ]
      },
      cpntMask: {
        required: false,
        type: String,
        validator: function (val) {
          return ([ null, 'cnpj_cpf', 'valor', 'valorDecimal', 'cnpj', 'cpf', 'placa', 'data', 'telefone', 'cep' ].indexOf(val) !== -1)
        },
        default: function () {
          return null
        }
      },
      cpntAutoComplete: {
        type: String,
        required: false,
        default: 'off'
      },
      cpntDisabled: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntMostrar: {
        type: Boolean,
        required: false,
        default: function () {
          return true
        }
      },
      cpntAutoFocus: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntPlaceholder: {
        type: String,
        required: false,
        default: ''
      },
      cpntMensagem: {
        type: String,
        required: false,
        default: null
      },
      cpntMensagemTipo: {
        type: String,
        required: false,
        default: null
      },
      cpntExplica: {
        type: Object,
        required: false
      },
      cpntClassDivField: {
        required: false,
        type: [ String, Array ],
        default: function () {
          return []
        }
      },
      cpntMaxLength: {
        type: Number,
        required: false,
        default: function () {
          return 99999999
        }
      },

      // FUNÇOES DO COMPONENT
      cpntOnChange: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOnKeyPressEnter: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOnBlur: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOnFocus: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        // value: this.cpntValue
        colors: {
          hex: this.cpntValue,
        },
        colorValue: '',
        displayPicker: false,
      }
    },
    mounted: function () {
      this.setColor(this.cpntValue || '#000000');
    },
    methods: {
      setColor(color) {
        this.updateColors(color);
        this.colorValue = color;
      },
      updateColors(color) {
        if(color.slice(0, 1) == '#') {
          this.colors = {
            hex: color
          };
        }
        else if(color.slice(0, 4) == 'rgba') {
          var rgba = color.replace(/^rgba?\(|\s+|\)$/g,'').split(','),
            hex = '#' + ((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).slice(1);
          this.colors = {
            hex: hex,
            a: rgba[3],
          }
        }
      },
      showPicker() {
        document.addEventListener('click', this.documentClick);
        this.displayPicker = true;
      },
      hidePicker() {
        document.removeEventListener('click', this.documentClick);
        this.displayPicker = false;
      },
      togglePicker() {
        this.displayPicker ? this.hidePicker() : this.showPicker();
      },
      updateFromInput() {
        this.updateColors(this.colorValue);
      },
      updateFromPicker(color) {
        this.colors = color;
        if(color.rgba.a == 1) {
          this.colorValue = color.hex;
        }
        else {
          this.colorValue = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')';
        }
      },
      documentClick(e) {
        var el = this.$refs.colorpicker,
          target = e.target;
        if(el !== target && !el.contains(target)) {
          this.hidePicker()
        }
      }
    },
    watch: {
      colorValue(val) {
        if ([ '', null, undefined ].indexOf(val) === -1) {
          this.updateColors(val);
          this.$emit('input', val);

          // CHAMA A FUNÇÃO PARA ATUALIZAR O COMPONENT PAI
          this.cpntOnChange(val, this.cpntId)
        }
      },
      cpntValue: function () {
        if ([ '', null, undefined ].indexOf(this.cpntValue) === -1) {
          this.updateColors(this.cpntValue);
          this.$emit('input', this.cpntValue);
        }
      }
    }
  }
</script>
